export const CREATE_QNA = 'CREATE_QNA';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILD = 'CREATE_FAILD';

